import { render } from "./EmployeeReportTo.vue?vue&type=template&id=5cf2bb3a"
import script from "./EmployeeReportTo.vue?vue&type=script&lang=js"
export * from "./EmployeeReportTo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__